import React from 'react';

import './EllipsisTextCell.scss';

export interface EllipsisTextCellProps {
  getValue: () => string;
}

const EllipsisTextCell = ({ getValue }: EllipsisTextCellProps) => (
  <span className="enkrateia-ellipsis-text-cell">{getValue()}</span>
);

export default EllipsisTextCell;
